<template>
  <v-flex xs6>
    <v-card raised height="100%">
      <v-container>
        <v-layout column>
          <v-flex>{{ name }}</v-flex>
          <v-flex>
            <class-view v-for="c in classes" v-bind:key="c.id" v-bind:classItem="c"></class-view>
          </v-flex>
        </v-layout>
      </v-container>
    </v-card>
  </v-flex>
</template>

<script>
  import ClassView from "./ClassView.vue";

  export default {
    components: {
      ClassView
    },
    props: ["dayItem"],
    data() {
      return {
        index: this.dayItem.index,
        name: this.dayItem.name,
        classes: this.dayItem.classes
      };
    }
  };
</script>

<style>
</style>